var _mask, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubtract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "subtract-mask"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.837 16c4.517 0 8.178-3.582 8.178-8s-3.662-8-8.178-8C4.321 0 .659 3.582.659 8s3.662 8 8.178 8Zm.656-7.341h3.025v-.982H5.48v.982h4.013Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.837 16c4.517 0 8.178-3.582 8.178-8s-3.662-8-8.178-8C4.321 0 .659 3.582.659 8s3.662 8 8.178 8Zm.656-7.341h3.025v-.982H5.48v.982h4.013Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.518 8.659v2h2v-2h-2Zm0-.982h2v-2h-2v2Zm-7.038 0v-2h-2v2h2Zm0 .982h-2v2h2v-2ZM15.015 8c0 3.273-2.724 6-6.178 6v4c5.58 0 10.178-4.436 10.178-10h-4ZM8.837 2c3.454 0 6.178 2.728 6.178 6h4c0-5.564-4.599-10-10.178-10v4ZM2.659 8c0-3.272 2.724-6 6.178-6v-4C3.257-2-1.341 2.436-1.341 8h4Zm6.178 6c-3.454 0-6.178-2.727-6.178-6h-4c0 5.564 4.599 10 10.178 10v-4Zm3.681-7.341H9.493v4h3.025v-4Zm-2 1.018v.982h4v-.982h-4Zm-1.025 2h3.025v-4H9.493v4Zm-.995 0h.995v-4h-.995v4Zm-3.018 0h3.018v-4H5.48v4Zm2-1.018v-.982h-4v.982h4Zm1.018-2H5.48v4h3.018v-4Zm.995 0h-.995v4h.995v-4Z",
    mask: "url(#subtract-mask)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.128243b8f4547e3fa98cdf18ad4fab83.svg";
export { ForwardRef as ReactComponent };